import { ProposalStatusPageContent } from '../components/management/proposalStatus/ProposalStatusPageContent'

export const ProposalStatusPage = () => {
  return <ProposalStatusPageContent />
}
